import React, { useState } from 'react';
import Modal from 'react-modal';
import { useTranslationContext } from "./project-builder-main.jsx";
import { useEditProject } from "../../../components/project-builder-custom-hooks";
import { formatUnicorn } from "../../../../shared/utils";


export default function ArchiveModal({ isArchiveOpen, closeArchiveModal, projectId, projectName }) {

    const {translations} = useTranslationContext();

    Modal.setAppElement('#main');

    const { mutate: editProject, isLoading } = useEditProject(projectId);

    const handleArchiveProject = () => {
        let projectData = {
            id: projectId,
            status: "Archived"
        };

        editProject(projectData, {
            onSuccess: () => {
                closeArchiveModal();
            }
        });
    }

    return (
        <>
            <Modal
                isOpen={isArchiveOpen}
                onRequestClose={closeArchiveModal}
                className="project-builder project-builder-modal project-builder-modal--xs text-center"
            >
                <button className="project-builder-modal-close" onClick={closeArchiveModal}>
                    <svg id="header-ask-close-svg" className="icon icon-close"><use xlinkHref="#icon-close"></use></svg>
                </button>
                <div className="container">
                    <div className='modal-title mb-2'>{formatUnicorn(translations.ArchiveModalConfirm, projectName)}</div>
                    <button type="button" className="btn no-arrow mb-1" disabled={isLoading} onClick={handleArchiveProject}>{translations.ArchiveModalYes}</button>
                    <div>
                        <button className="link-btn" disabled={isLoading} onClick={closeArchiveModal}>{translations.ArchiveModalNo}</button>
                    </div>
                </div>
            </Modal>
        </>
    );
}